import { createFileRoute } from '@tanstack/react-router'
import { ForgotPasswordPage } from '@/pages/authentication/ui/ForgotPasswordPage'

export const Route = createFileRoute('/forgot-password')({
  component: ForgotPasswordPage,
})
